export const OG_TYPE_ARTICLE = 'article'
export const OG_TYPE_WEBSITE = 'website'
export const OG_TYPE_VIDEO_MOVIE = 'video.movie'
export const OG_TYPE_VIDEO_EPISODE = 'video.episode'
export const OG_TYPE_VIDEO_TV_SHOW = 'video.tv_show'
